import { Card, CardMedia, Typography, styled } from '@mui/material';
import { SwiperSlide } from 'swiper/react';

import { multilineEllipsisOverflow } from 'theSource/utils';

export const CardStyled = styled(Card)(({ theme }) => ({
  maxWidth: '100%',
  boxShadow: theme.customShadow,
}));

export const CardMediaStyled = styled(CardMedia)(({ theme }) => ({
  height: theme.spacing(35),
})) as typeof CardMedia;

export const CardTextStyled = styled(Typography)(({ theme }) => ({
  height: theme.spacing(10),
  maxHeight: theme.spacing(10),
  ...multilineEllipsisOverflow(2),
})) as typeof Typography;

export const SwiperSlideStyled = styled(SwiperSlide)(({ theme }) => ({
  padding: theme.spacing(3, 0),
})) as typeof SwiperSlide;
